// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"268":"Home","892":"PageNotFound"}[chunkId] + "." + {"268":"6107a5cf","892":"28fcdfa2"}[chunkId] + ".js";
};